import React from 'react';
import './createPlantDetails.css';
import './createPlant.css';
import 'react-toastify/dist/ReactToastify.css';
import { useCreatePlantDetails } from './useCreatePlantDetails';
import { CreatePlantDetailsView } from './CreatePlantDetailsView';

const CreatePlantDetails: React.FC = () => {
    const viewProps = useCreatePlantDetails();
    return <CreatePlantDetailsView {...viewProps} />;
};

export default CreatePlantDetails;
